// DOM elements
const loginForm = document.getElementById("login")
const registerForm = document.getElementById("register")
const eventForm = document.getElementById("event")
const changePasswordForm = document.getElementById("change-password")

// Handle login form submit
if (loginForm) {
    loginForm.addEventListener("submit", (event) => {
        event.preventDefault()
        event.stopPropagation()
        sendPost(event.target)
    })
}

// Handle register form submit
if (registerForm) {
    registerForm.addEventListener("submit", (event) => {
        event.preventDefault()
        event.stopPropagation()
        const checkbox = document.getElementById("datenschutz")
        if (!checkbox.checked) {
            showAlert(event.target, false, "Bitte bestätigen Sie die Bedingungen durch Ankreuzen des Kästchens.", { "datenschutz": "" })
            return false
        }
        sendPost(event.target)
    })
}

// Handle join event form submit
if (eventForm) {
    eventForm.addEventListener("submit", (event) => {
        event.preventDefault()
        event.stopPropagation()
        sendPost(event.target)
    })
}

// Handle change password event form submit
if (changePasswordForm) {
    changePasswordForm.addEventListener("submit", (event) => {
        event.preventDefault()
        event.stopPropagation()
        sendPost(event.target)
    })
}

// Send form content as POST request
const sendPost = (form) => {
    const request = new XMLHttpRequest()
    const formData = new FormData(form)
    const url = ""
    request.open("POST", url, true)

    // Clear error borders and notices
    clearForm()

    // Handle response
    request.onreadystatechange = () => {
        if (request.readyState == 4) {
            if (request.status == 200) {
                response = JSON.parse(request.responseText)
                showAlert(form, response.success, response.message, response.error_fields)
            }
            else {
                showAlert(false, "Es gab ein Problem mit der Beschaffung. Bitte versuchen Sie es später noch einmal.")
            }
        }
    }
    request.send(formData)
    return true
}

// Send form content as POST request
const applySearch = (form) => {
    const request = new XMLHttpRequest()
    const formData = new FormData(form)
    const url = "/suche/"
    request.open("POST", url, true)

    // Handle response
    request.onreadystatechange = () => {
        if (request.readyState == 4) {
            if (request.status == 200) {
                response = JSON.parse(request.responseText)
                if (response.search_result) {
                    const searchResultContainer = document.getElementById("search-results")
                    searchResultContainer.innerHTML = response.search_result
                }
            } else {
                showAlert(false, "Es gab ein Problem mit der Beschaffung. Bitte versuchen Sie es später noch einmal.")
            }
        }
    }
    request.send(formData)
    return true
}

// Clear inputfield error borders, notices and form alerts
const clearForm = () => {
    const invalidInputs = document.querySelectorAll('.border-brand-error')
    invalidInputs.forEach((input) => {
        input.classList.remove("border-brand-error")
    })

    const errorNotices = document.querySelectorAll('.error-notice')
    errorNotices.forEach((notice) => {
        notice.remove()
    })

    const errorAlerts = document.querySelectorAll('.error-alert')
    errorAlerts.forEach((alert) => {
        alert.remove()
    })
}

// Show alert - Dynamic message and contextual class (success/error)
const showAlert = (form, success, message, errorFields = {}) => {

    // Create new alert box and add it to DOM
    const alert = document.createElement("div")
    alert.classList.add("w-full", "my-4", "p-4", "bg-opacity-10", "error-alert")
    if (success) {
        alert.classList.add("text-brand-success", "bg-brand-success")
    } else {
        alert.classList.add("bg-brand-error", "text-brand-error")
    }
    alert.textContent = message
    form.prepend(alert)
    alert.scrollIntoViewIfNeeded()

    // Mark error fields as invalid
    if (Object.keys(errorFields).length) {
        Object.entries(errorFields).forEach(errorField => {
            const [fieldName, errorMessage] = errorField
            const field = document.querySelector(`[name='${fieldName}']`)
            if (field) {
                field.classList.remove("border-brand-black", "border-white")
                field.classList.add("border-brand-error")

                // Create new error notice under field
                if (errorMessage) {
                    const errorNotice = document.createElement("p")
                    errorNotice.classList.add("text-red", "text-sm", "p-0", "m-0", "text-brand-error", "error-notice")
                    errorNotice.textContent = errorMessage
                    field.after(errorNotice)
                }
            }
        })
    }

    // Redirect after success login
    if (success && form.id === "login") {
        window.location.href = "/user"
    }

    // Hide form after success registration
    if (success && (form.id === "register" || form.id === "event")) {
        document.getElementById('form_content').style.display = "none"
        document.getElementById('register_btn').style.display = "none"

        // After registration, the "Einloggen" becomes primary
        const loginRedirectBtn = document.getElementById('login_redirect')
        const registerBtn = document.getElementById('register_btn')
        if(loginRedirectBtn && registerBtn) {
            registerBtn.remove()
            loginRedirectBtn.classList.remove("text-brand-grey-darker")
            loginRedirectBtn.classList.add("btn", "btn-primary-invert", "bg-brand-orange", "text-base", "px-6", "font-semi-bold", "bg-brand-orange")
        }
    }
}

// Hide honeypot inputfield with Javascript - Most bots don't have javascript enabled
window.addEventListener("load", function () {
    const honeypot = document.getElementById("address")
    if (honeypot) {
        honeypot.closest("div").classList.add("cloak")
    }
}, false)

// Logic for "Weitere Artikel laden" button on overview sites
window.addEventListener("load", function () {
    const showMoreBtn = document.getElementById('show-more')
    let limit = 6

    // Execute filter with default values
    if (showMoreBtn) {
        applyFilter()
        bindShowMoreBtn()
    }

    function applyFilter() {
        // Hide all cards
        let cards = document.querySelectorAll(".overview-card")
        let showMoreBtn = document.getElementById('show-more');
        [].forEach.call(cards, function (el) {
            el.style.display = 'none'
        })

        // Show only filtered cards inside of limit
        var filteredArray = [...cards]
        var showElements = filteredArray.slice(0, limit);

        [].forEach.call(showElements, function (el) {
            el.style.display = 'block'
        })

        // Toggle show more button
        if (showElements.length < limit) {
            showMoreBtn.style.visibility = 'hidden'
        } else {
            showMoreBtn.style.visibility = 'visible'
        }
    }

    // Watch show more click
    function bindShowMoreBtn() {
        const showMoreBtn = document.getElementById('show-more')
        if (showMoreBtn) {
            showMoreBtn.addEventListener('click', function () {
                limit += 6
                applyFilter()
            })
        }
    }

    // Search
    const searchForm = document.getElementById("search")
    if (searchForm) {
        searchForm.addEventListener("submit", (event) => {
            event.preventDefault()
            event.stopPropagation()
            applySearch(event.target)
            setTimeout(function () {
                applyFilter()
                bindShowMoreBtn()
            }, 500);
        })
    }
}, false)

// Navigation
const mobile_icon = document.getElementById('mobile-icon');
const mobile_menu = document.getElementById('mobile-menu');

function openCloseMenu() {
    mobile_menu.classList.toggle('block');
    mobile_menu.classList.toggle('active');

    const mobileMenuItems = mobile_menu.querySelectorAll('.mobile-menu-btn')
    mobileMenuItems.forEach((item) => {
        if(item.querySelector('.mobile-menu-subnav') && item.querySelector('.mobile-menu-subnav').classList.contains('open')) {
            item.querySelector('.mobile-menu-subnav').classList.remove('open')
        }
        if(item.querySelector('.icon-arrow-down') && item.querySelector('.icon-arrow-down').classList.contains('rotate-180')) {
            item.querySelector('.icon-arrow-down').classList.remove('rotate-180')
        }
        if(item.querySelector('.icon-arrow-down') && item.querySelector('.icon-arrow-down').classList.contains('transform')) {
            item.querySelector('.icon-arrow-down').classList.remove('transform')
        }
    })
}

mobile_icon.addEventListener('click', openCloseMenu);

// open submenus of navigation
// desktop nav
const menuBtn = document.querySelectorAll('.menu-btn')
menuBtn.forEach((btn) => btn.addEventListener('click', e => {
    if(e.currentTarget.querySelector('.nav-submenu')) {
        if( e.currentTarget.querySelector('.nav-submenu').classList.contains('open')) {
            e.currentTarget.querySelector('.nav-submenu').classList.remove('open')
        } else {
            // close all open submenus
            document.querySelectorAll('.nav-submenu').forEach((sub) => sub.classList.remove('open'))
            // open only the current selected submenu
            e.currentTarget.querySelector('.nav-submenu').classList.add('open')
        }
    }

    if(e.currentTarget.querySelector('.icon-arrow-down')) {
        if(e.currentTarget.querySelector('.icon-arrow-down').classList.contains('rotate-180')) {
            e.currentTarget.querySelector('.icon-arrow-down').classList.remove('rotate-180')
            e.currentTarget.querySelector('.icon-arrow-down').classList.remove('transform')
        } else {
            e.currentTarget.querySelector('.icon-arrow-down').classList.add('rotate-180')
            e.currentTarget.querySelector('.icon-arrow-down').classList.add('transform')
        }
    }
}))

// mobile nav
const mobileMenuBtn = document.querySelectorAll('.mobile-menu-btn')
mobileMenuBtn.forEach((btn) => btn.addEventListener('click', e => {
    if(e.currentTarget.querySelector('.mobile-menu-subnav')) {
        if(e.currentTarget.querySelector('.mobile-menu-subnav').classList.contains('open')) {
            e.currentTarget.querySelector('.mobile-menu-subnav').classList.remove('open')
        } else {
            e.currentTarget.querySelector('.mobile-menu-subnav').classList.add('open')
        }
    }
    if(e.currentTarget.querySelector('.icon-arrow-down')) {
        if(e.currentTarget.querySelector('.icon-arrow-down').classList.contains('rotate-180')) {
            e.currentTarget.querySelector('.icon-arrow-down').classList.remove('rotate-180')
            e.currentTarget.querySelector('.icon-arrow-down').classList.remove('transform')
        } else {
            e.currentTarget.querySelector('.icon-arrow-down').classList.add('rotate-180')
            e.currentTarget.querySelector('.icon-arrow-down').classList.add('transform')
        }
    }
}))

const menuList = document.querySelector('.menu-list')
hideOnClickOutside(menuList)

// Detect click outside element (close menu when click outside)
function hideOnClickOutside(element) {
    const outsideClickListener = event => {
        if (!element.contains(event.target) && isVisible(element)) { // or use: event.target.closest(selector) === null
            const menuItems = element.querySelectorAll('.menu-btn')
            
            menuItems.forEach((item) => {
                item.querySelector('.nav-submenu') && item.querySelector('.nav-submenu').classList.remove('open')
                item.querySelector('.icon-arrow-down') && item.querySelector('.icon-arrow-down').classList.remove('rotate-180')
                item.querySelector('.icon-arrow-down') && item.querySelector('.icon-arrow-down').classList.remove('transform')
            })
        }
    }

    document.addEventListener('click', outsideClickListener);
}

const isVisible = elem => !!elem && !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );


// Navigation submenu: Change submenu position according to viewport space
const submenus = document.querySelectorAll('.nav-submenu')
submenus.forEach((sub) => {
    const pos = sub.getBoundingClientRect()

    if ((window.innerWidth - pos.left - pos.width) < 0) {
        sub.classList.add('right-0', 'before:right-8')
    }
})

// Accordion
const accordionHeader = document.querySelectorAll(".accordion-header");
accordionHeader.forEach((header) => {
    header.addEventListener("click", function () {
        const accordionContent = header.parentElement.querySelector(".accordion-content");
        let accordionMaxHeight = accordionContent.style.maxHeight;

        // Condition handling
        if (accordionMaxHeight == "0px" || accordionMaxHeight.length == 0) {
            accordionContent.style.maxHeight = `${accordionContent.scrollHeight + 32}px`;
            header.querySelector(".icon").classList.remove("rotate-45");
            // header.querySelector(".icon").classList.add("rotate-90");
        } else {
            accordionContent.style.maxHeight = `0px`;
            header.querySelector(".icon").classList.add("rotate-45");
            // header.querySelector(".icon").classList.remove("rotate-90");
        }
    });
});

// video player
const videos = document.querySelectorAll('.video-overlay');
videos.forEach((video) => {
    video.addEventListener('click', function handleClick() {
        // Get elements
        let previewImage = video.parentElement.querySelector('img')
        let videoElement = video.parentElement.querySelector('video')

        // Disable Video Overlay
        video.classList.add('hidden')
        if (previewImage) {
            previewImage.classList.add('hidden')
        }

        // Play Video and show controls
        videoElement.setAttribute('controls', 'true')
        videoElement.play()
    });
})

// Modal
document.addEventListener('click', function (e) {
    const target = e.target

    // Open modal
    if ((target.hasAttribute('data-toggle') && target.getAttribute('data-toggle') === 'modal') ||
        (target.parentElement.hasAttribute('data-toggle') && target.parentElement.getAttribute('data-toggle') === 'modal')) {
        if (target.hasAttribute('data-target')) {
            document.getElementById(target.getAttribute('data-target')).classList.add('open');
            document.getElementById(target.getAttribute('data-target')).classList.remove('opacity-0', 'invisible');
            document.getElementById(target.getAttribute('data-target')).classList.add('opacity-100', 'visible');
            e.preventDefault();
        }
        if (target.parentElement.hasAttribute('data-toggle')) {
            document.getElementById(target.parentElement.getAttribute('data-target')).classList.add('open');
            document.getElementById(target.parentElement.getAttribute('data-target')).classList.remove('opacity-0', 'invisible');
            document.getElementById(target.parentElement.getAttribute('data-target')).classList.add('opacity-100', 'visible');
            e.preventDefault();
        }
    }

    // Close modal window with 'data-dismiss' attribute or when the backdrop is clicked
    if ((target.hasAttribute('data-dismiss') && target.getAttribute('data-dismiss') === 'modal') || target.classList.contains('modal')) {
        document.querySelector('.modal.open').classList.add('opacity-0', 'invisible');
        document.querySelector('.modal.open').classList.remove('opacity-100', 'visible');
        document.querySelector('.modal.open').classList.remove('open');
        e.preventDefault();
    }
}, false);


window.addEventListener("load", function () {
    document.getElementById('main-content').style.display = 'block'
    document.getElementById('main-content-loader').style.display = 'none'
}, false);
